import React from 'react';
import { useIframeCommunication } from '../../hooks/useIframeCommunication';
import Footer from '../../components/Footer';
import TherapistsTermsContent from '../../components/TherapistsTermsContent';
import './TherapistsTermsPage.css';
export default function TherapistsTermsPage() {
  useIframeCommunication();
  return <div className="therapists-terms-page"><TherapistsTermsContent /><Footer /></div>;
}
